import { TFieldProps } from 'types';

export const enFields: TFieldProps[] = [{
  type: TFieldProps.type.ImageUpload,
  name: ['enValues', 'imageMetadataId'],
  label: 'Retailer Logo',
  entityType: 'RETAILER',
}, {
  type: TFieldProps.type.Text,
  name: ['enValues', 'name'],
  label: 'Retailer Name in English',
  rules: [{
    required: true,
    message: 'Retailer Name is required!',
  }],
}, {
  type: TFieldProps.type.Text,
  name: ['enValues', 'nameTemplate'],
  label: 'Name Template',
  placeholder: '\bword1\\W+(?:\\w+\\W+){1,6}?word2\b',
}];

export const frFields: TFieldProps[] = [{
  type: TFieldProps.type.ImageUpload,
  name: ['frValues', 'imageMetadataId'],
  label: 'Retailer Logo',
  entityType: 'RETAILER',
}, {
  type: TFieldProps.type.Text,
  name: ['frValues', 'name'],
  label: 'Retailer Name in French',
  rules: [{
    required: true,
    message: 'Retailer Name is required!',
  }],
}, {
  type: TFieldProps.type.Text,
  name: ['frValues', 'nameTemplate'],
  label: 'Name Template',
  placeholder: '\bword1\\W+(?:\\w+\\W+){1,6}?word2\b',
}];
